import Payment from "./components/Payment";
export default Payment;
export * from '@solidgate/client-sdk-loader';
//# sourceMappingURL=index.js.map